import React from 'react';
import { FormattedMessage } from 'react-intl';

import Spinner from './Spinner';

const OverlaySpinner = ({ children }) => (
    <div className="overlay-spinner">
        <Spinner />
        {children}
    </div>
);

OverlaySpinner.defaultProps = {
    children: (
        <React.Fragment>
            <p>
                <FormattedMessage id="spinner.message.1" />
            </p>
            <p>
                <FormattedMessage id="spinner.message.2" />
            </p>
        </React.Fragment>
    ),
};

export default OverlaySpinner;
